import { APP_BACKGROUND_COLOR, BORDER_COLOR } from "../../theme";

export const styles = {
  musicNoteImageMainContainer: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  } as const,
  musicNoteImageContainer: {
    display: "flex",
    border: "1px solid gray",
    padding: "10px",
    borderRadius: "10px",
    width: "50px",
    marginBottom: "10px",
  } as const,
  audioPlayerContainer: {
    backgroundColor: APP_BACKGROUND_COLOR,
    height: 250,
    borderColor: BORDER_COLOR,
    borderRadius: "15px",
  } as const,
};
